// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FILTER_MODAL_CLOSE = "Zav\u0159\u00edt";
export const BZ2_NO_SUCH_OPTION = "\u017d\u00e1dn\u00e1 takov\u00e1 mo\u017enost tu nen\u00ed.";
export const CONFIRM = "Potvr\u010f";
